// Libraries
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params }   from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import * as moment from 'moment';
// Services
import { BookingHolidayService } from '../../../services';
import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';

@Component({
    selector: 'class-payment',
    template: require('./BusOptionComponent.html'),
    styles: [ require('./BusOptionComponent.sass') ]
})

export class BusOptionComponent extends BookingComponent implements OnInit {
    private booking: any
    // For bus
    private checkBus: any;
    private checkFreeBus: any
    private freeBus: any = {}
    private checkPaidBus: any
    private paidBus: any = {}
    private paidBus2: any = {}
    private checkPaidBus2: any

    private agree: any = ''
    private showAgreeWarning: boolean = false;
    private showWarning: boolean = false;

    // For Bus booking
    private selectedChild: any
    private minAge: number = 5
    private isAllowed: boolean = true;
    // For update
    private currentBusId: number = 0;
    
    currentSemester: any = {
        name: ''
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
        protected location: Location,
        protected catalogService?: CatalogService
    ){
        super(router, services, sessionStorageService, catalogService);

        this.freeBus.price = 0;
        this.freeBus.district = 'Quan 1';
        this.paidBus.district = 'Binh Thanh';
        this.paidBus2.district = 'Others';
        
        // this.paidBus.price = 1
    }

    ngOnInit() {
        this.selectedChild = this.getSelectedChild();
        // Check if selected child is 5 years old or younger
        if(moment().diff(moment(this.selectedChild.date_of_birth), 'years', true) <= 5){
            this.isAllowed = false;
        }
        // Get booking info from session
        this.booking = this.getBooking();
        this.getSemester();
        // Initial booking
        this.initBooking();
    }
    // Initial booking info from session
    initBooking() {
        if(!_.isEmpty(this.booking.bus)){
            // Detect saved bus type
            if(this.booking.busType == 'free'){
                this.checkFreeBus = true;
                this.freeBus = this.booking.bus;
            }
            if(this.booking.busType == 'paid' && this.booking.bus.district === 'Binh Thanh'){
                this.checkPaidBus = true;
                this.paidBus = this.booking.bus;
            }
            else if (this.booking.busType == 'paid' && this.booking.bus.district === 'Others') {
                this.checkPaidBus2 = true;
                this.paidBus2 = this.booking.bus;
            }
            // Set agreement
            this.agree = true;
            // Set update bus id
            this.currentBusId = this.booking.bus.id;
        }
    }

    // Download Bus registration form
    downloadBusRegistrationForm(){
        const link = window.document.createElement('a');
        link.href = '/assets/Holiday Bus Registration Form.pdf';
        link['download'] = "Holiday Bus Registration Form.pdf";
        
        document.body.appendChild(link);
        link.click();

        setTimeout(function(){
            document.body.removeChild(link);
        }, 100);
    }
    handleChange(payment: any) {      
        if(this.checkBus === 'freeBus') {
            this.checkFreeBus = 'freeBus'
            this.checkPaidBus = undefined;
            this.checkPaidBus2 = undefined;
        }
        if(this.checkBus === 'paidBus') {
            this.checkFreeBus = undefined;
            this.checkPaidBus = 'paidBus';
            this.checkPaidBus2 = undefined;
        }
        if(this.checkBus === 'paidBus2') {
            this.checkFreeBus = undefined;
            this.checkPaidBus = undefined;
            this.checkPaidBus2 = 'paidBus2';
        }
    }
    // Submit function
    submitBusOption(){
        // Set bus array
        this.booking.bus = {};
        this.booking.busType = '';
        if(this.checkFreeBus){ 
            this.booking.bus = this.freeBus;
            this.booking.busType = 'free';
        }

        if(this.checkPaidBus){
            this.booking.bus = this.paidBus;
            this.booking.busType = 'paid';
        }

        if(this.checkPaidBus2){
            this.booking.bus = this.paidBus2;
            this.booking.busType = 'paid';
        }
        if(this.checkFreeBus || this.checkPaidBus || this.checkPaidBus2){
            if(this.checkFreeBus && (!this.freeBus.district || !this.freeBus.address)){
                return this.showWarning = true;
            }
            
            if(this.checkPaidBus && (!this.paidBus.district || !this.paidBus.address)){
                return this.showWarning = true;
            }
            
            if(this.checkPaidBus2 && (!this.paidBus2.district || !this.paidBus2.address)){
                return this.showWarning = true;
            }

            if(!this.agree){
                return this.showAgreeWarning = true;
            }
            else{
                // Depends on free or paid bus checked we collect information
                // Set bus type in session
                if(this.checkFreeBus){
                    this.booking.bus = this.freeBus;
                    this.booking.busType = 'free';
                }

                if(this.checkPaidBus){
                    this.booking.bus = this.paidBus;
                    this.booking.busType = 'paid';
                }

                if(this.checkPaidBus2){
                    this.booking.bus = this.paidBus2;
                    this.booking.busType = 'paid';
                }

                // Set bus id
                if(this.currentBusId){
                    this.booking.bus.id = this.currentBusId;                    
                }
                
                // Store booking information
                this.setBooking(this.booking);
                // Navigate to next page
                this.router.navigate(['booking/payment']);
            }
        }
        else{
            // Store booking information
            this.setBooking(this.booking);
            // Navigate to next page
            this.router.navigate(['booking/payment']);
        }
    }

    /**
    * @Jira task: ECA-1364: Hol-parent - update additional fee
    * @author: Loc Nguyen
    * @description: get current semester
    */
    protected getSemester() { 
        this.catalogService.getSemesters()
            .subscribe(
                semesterList => {
                    this.currentSemester = _.find(semesterList, 'is_current');
                },
                error => {
                    console.log("Cannot get semester list from API.");
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/5-bus-option/BusOptionComponent.ts